import React, { FC, useState } from 'react';
import { styled } from 'linaria/react';
import { Icon, useBreakpoint } from '@mtsbank/ui-kit';
import { useCyberStore } from '@entities/tsp';
import { useTheme } from '@shared/lib';
import { ToolTipText, ToolTipMobileText } from '@shared/ui/atoms';
import { OldButton } from '@shared/ui/atoms/OldButton';
interface Props {
  showVouchersForm: boolean;
  setShowVouchersForm: (showVouchersForm: boolean) => void;
}
const SwitchReplenishmentMethod: FC<Props> = ({
  showVouchersForm,
  setShowVouchersForm
}) => {
  const [isVoucherInfoModalActive, setIsVoucherInfoModalActive] = useState(false);
  const {
    isMobile
  } = useBreakpoint();
  const theme = useTheme();
  const {
    setAmountInfo
  } = useCyberStore();
  const handleVoucherInfoModalSwitch = e => {
    e?.stopPropagation();
    setIsVoucherInfoModalActive(prev => !prev);
  };
  const handleHideVouchersForm = () => {
    setShowVouchersForm(false);
    setAmountInfo(null);
  };
  const handleShowVouchersForm = () => {
    setShowVouchersForm(true);
    setAmountInfo(null);
  };
  return <>
      <ButtonGroup>
        <OldButton title="Пополнить аккаунт" onClick={handleHideVouchersForm} isActive={!showVouchersForm} />
        <OldButton title="Ваучер" onClick={handleShowVouchersForm} isActive={showVouchersForm} tooltip={isMobile ? <Icon onClick={handleVoucherInfoModalSwitch} icon="baseX24/question-circle" fill={showVouchersForm ? theme.colors.icon.primary : theme.colors.icon.tertiary} style={{
        marginLeft: '-2px',
        marginRight: '-4px'
      }} /> : <ToolTipText interactive placement="bottom" zIndex={999} onHidden={() => {}} onClick={e => {
        e.stopPropagation();
      }} hint="Ваучер – уникальная комбинация из цифр и букв. У ваучера есть денежный номинал, который зачисляется на игровой кошелек при активации." activeCountrySteam={showVouchersForm ? 'Страны СНГ' : ''} isActive={showVouchersForm} style={{
        marginLeft: '-2px',
        marginRight: '-3px'
      }} />} />
      </ButtonGroup>
      <ToolTipMobileText open={isVoucherInfoModalActive} title="Что такое ваучер?" handleClose={handleVoucherInfoModalSwitch}>
        Ваучер – уникальная комбинация из цифр и букв. У ваучера есть денежный номинал, который зачисляется на игровой
        кошелек при активации.
      </ToolTipMobileText>
    </>;
};
export default SwitchReplenishmentMethod;
const ButtonGroup = /*#__PURE__*/styled('div')({
  name: "ButtonGroup",
  class: "br78e60",
  propsAsIs: false
});

require("./SwitchReplenishmentMethod.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./SwitchReplenishmentMethod.tsx");